import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";

export interface SystemSettings {
  id?: string;
  app_version: string;
  plafond_send_usd?: string;
  plafond_payout_xaf?: string;
  charge_percent: string;
  local_operator_network_error: string;
  promo_share_template: string;
  app_download_url: string;
  withdrawal_notification_email?: string | null;
  created_at?: string;
  updated_at?: string;
}

export const systemService = {
  // Récupérer les informations système
  async getSystemInfo(token: string): Promise<SystemSettings> {
    try {
      const response = await axios.get(`${BACKEND_URL}/system/system_info`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data?.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des infos système:", error);
      throw error;
    }
  },

  // Modifier la version de l'application
  async changeAppVersion(appVersion: string, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_app_version`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            app_version: appVersion,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification de la version:", error);
      throw error;
    }
  },

  // Modifier le plafond d'envoi USD
  async changePlafondSendUsd(plafond: string, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_plafond_send_usd?plafond_send_usd=${plafond}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification du plafond d'envoi:", error);
      throw error;
    }
  },

  // Modifier le plafond de réception XAF
  async changePlafondReceiveXaf(plafond: string, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_plafond_receive_xaf?plafond_receive_xaf=${plafond}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification du plafond de réception:", error);
      throw error;
    }
  },

  // Modifier le pourcentage de frais
  async changeChargePercent(percent: string, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_charge_percent?charge_percent=${percent}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification du pourcentage de frais:", error);
      throw error;
    }
  },

  // Modifier le statut d'erreur réseau de l'opérateur local
  async changeLocalOperatorNetworkError(status: string, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_local_operator_network_error?local_operator_network_error=${status}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification du statut d'erreur réseau:", error);
      throw error;
    }
  },

  // Modifier le template du message de partage promo
  async changePromoShareTemplate(template: string, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_promo_share_template`,
        { promo_share_template: template },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification du template promo:", error);
      throw error;
    }
  },

  // Modifier l'URL de téléchargement de l'application
  async changeAppDownloadUrl(url: string, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_app_download_url`,
        { app_download_url: url },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification de l'URL de téléchargement:", error);
      throw error;
    }
  },

  // Modifier l'email de notification des demandes de retrait
  async changeWithdrawalNotificationEmail(email: string | null, token: string): Promise<void> {
    try {
      await axios.put(
        `${BACKEND_URL}/system/change_withdrawal_notification_email`,
        { withdrawal_notification_email: email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la modification de l'email de retrait:", error);
      throw error;
    }
  },
};
